import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';


var dhtmlXCalendarObject = (function () {
    function dhtmlXCalendarObject(l, s) {
        this.i = {};
        var e = null;
        var g = null;
        if (typeof l == "string") {
            g = document.getElementById(l);
        }
        else {
            g = l;
        }
        if (g &&
            typeof g == "object" &&
            g.tagName &&
            String(g.tagName).toLowerCase() != "input") {
            e = g;
        }
        g = null;
        if (typeof l != "object" || !l.length) {
            l = [l];
        }
        for (var c = 0; c < l.length; c++) {
            if (typeof l[c] == "string") {
                l[c] = document.getElementById(l[c]) || null;
            }
            if (l[c] != null &&
                l[c].tagName &&
                String(l[c].tagName).toLowerCase() == "input") {
                this.i[dhx4.newId()] = { input: l[c] };
            }
            else {
                if (!(l[c] instanceof Array) &&
                    l[c] instanceof Object &&
                    (l[c].input != null || l[c].button != null)) {
                    if (l[c].input != null && typeof l[c].input == "string") {
                        l[c].input = document.getElementById(l[c].input);
                    }
                    if (l[c].button != null && typeof l[c].button == "string") {
                        l[c].button = document.getElementById(l[c].button);
                    }
                    this.i[dhx4.newId()] = l[c];
                }
            }
            l[c] = null;
        }
        this.conf = {
            skin: s ||
                dhx4.skin ||
                (typeof dhtmlx != "undefined" ? dhtmlx.skin : null) ||
                dhx4.skinDetect("dhtmlxcalendar") ||
                "material",
            zi: dhx4.newId(),
            touch: !dhx4.isIE,
            time: true,
            today: false,
            ws_first: true
        };
        this.base = document.createElement("DIV");
        this.base.style.display = "none";
        this.base.appendChild(document.createElement("DIV"));
        if (e != null) {
            this._hasParent = true;
            e.appendChild(this.base);
            e = null;
        }
        else {
            document.body.appendChild(this.base);
        }
        this.setSkin(this.conf.skin, true);
        this.base.onclick = function (a) {
            a = a || event;
            if (a.preventDefault) {
                a.preventDefault();
            }
            a.cancelBubble = true;
        };
        this.base.onmousedown = function () {
            return false;
        };
        if (this.conf.touch) {
            this.base.ontouchstart = this.base.onclick;
        }
        this.contMonth = document.createElement("DIV");
        this.contMonth.className = "dhtmlxcalendar_month_cont";
        this.contMonth.onselectstart = function (a) {
            a = a || event;
            a.cancelBubble = true;
            if (a.preventDefault) {
                a.preventDefault();
            }
            else {
                a.returnValue = false;
            }
            return false;
        };
        this.base.firstChild.appendChild(this.contMonth);
        var m = document.createElement("UL");
        m.className = "dhtmlxcalendar_line";
        this.contMonth.appendChild(m);
        var r = document.createElement("LI");
        r.className = "dhtmlxcalendar_cell dhtmlxcalendar_month_hdr";
        r.innerHTML =
            "<div class='dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_left' onmouseover='this.className=\"dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_left_hover\";' onmouseout='this.className=\"dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_left\";'></div><span></span><div class='dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_right' onmouseover='this.className=\"dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_right_hover\";' onmouseout='this.className=\"dhtmlxcalendar_month_arrow dhtmlxcalendar_month_arrow_right\";'></div>";
        m.appendChild(r);
        var h = this;
        r.onclick = function (w) {
            w = w || event;
            if (w.type == "touchstart" && w.preventDefault != null) {
                w.preventDefault();
            }
            var u = w.target || w.srcElement;
            if (u.className &&
                u.className.indexOf("dhtmlxcalendar_month_arrow") === 0) {
                h._hideSelector();
                var v = u.parentNode.firstChild == u ? -1 : 1;
                var a = new Date(h._activeMonth);
                h._drawMonth(new Date(h._activeMonth.getFullYear(), h._activeMonth.getMonth() + v, 1, 0, 0, 0, 0));
                h._evOnArrowClick([a, new Date(h._activeMonth)]);
                return;
            }
            if (u.className && u.className == "dhtmlxcalendar_month_label_month") {
                w.cancelBubble = true;
                h._showSelector("month", Math.round(u.offsetLeft + u.offsetWidth / 2), u.offsetTop + u.offsetHeight + 2, "selector_month", true);
                return;
            }
            if (u.className && u.className == "dhtmlxcalendar_month_label_year") {
                w.cancelBubble = true;
                h._showSelector("year", Math.round(u.offsetLeft + u.offsetWidth / 2), u.offsetTop + u.offsetHeight + 2, "selector_year", true);
                return;
            }
            h._hideSelector();
        };
        if (this.conf.touch == true) {
            r.ontouchstart = r.onclick;
        }
        this.contDays = document.createElement("DIV");
        this.contDays.className = "dhtmlxcalendar_days_cont";
        this.base.firstChild.appendChild(this.contDays);
        this._wStart = this.langData[this.lang].weekstart;
        this.setWeekStartDay(this._wStart);
        this.contDates = document.createElement("DIV");
        this.contDates.className = "dhtmlxcalendar_dates_cont";
        this.base.firstChild.appendChild(this.contDates);
        this.contDates.onclick = function (y) {
            y = y || event;
            if (y.type == "touchstart" && y.preventDefault != null) {
                y.preventDefault();
            }
            var u = y.target || y.srcElement;
            if (u.parentNode != null && u.parentNode._date != null) {
                u = u.parentNode;
            }
            if (u._date != null && !u._css_dis) {
                var w = h._activeDate.getHours();
                var v = h._activeDate.getMinutes();
                var x = u._date;
                if (h.checkEvent("onBeforeChange")) {
                    if (!h.callEvent("onBeforeChange", [
                        new Date(u._date.getFullYear(), u._date.getMonth(), u._date.getDate(), w, v)
                    ])) {
                        return;
                    }
                }
                if (h._activeDateCell != null) {
                    h._activeDateCell._css_date = false;
                    h._updateCellStyle(h._activeDateCell._q, h._activeDateCell._w);
                }
                var a = h._activeDate.getFullYear() + "_" + h._activeDate.getMonth() !=
                    x.getFullYear() + "_" + x.getMonth();
                h._nullDate = false;
                h._activeDate = new Date(x.getFullYear(), x.getMonth(), x.getDate(), w, v);
                h._activeDateCell = u;
                h._activeDateCell._css_date = true;
                h._activeDateCell._css_hover = false;
                h._updateCellStyle(h._activeDateCell._q, h._activeDateCell._w);
                if (a) {
                    h._drawMonth(h._activeDate);
                }
                h._updateInp();
                if (!h._hasParent) {
                    if (y.type == "touchstart") {
                        window.setTimeout(function () {
                            h._hide();
                        }, 400);
                    }
                    else {
                        h._hide();
                    }
                }
                h._evOnClick([new Date(h._activeDate.getTime())]);
            }
        };
        if (this.conf.touch == true) {
            this.contDates.ontouchstart = this.contDates.onclick;
        }
        this.contDates.onmouseover = function (u) {
            u = u || event;
            var a = u.target || u.srcElement;
            if (a.parentNode != null && a.parentNode._date != null) {
                a = a.parentNode;
            }
            if (a._date != null) {
                if (h._lastHover == a || a._css_hover) {
                    return;
                }
                a._css_hover = true;
                h._updateCellStyle(a._q, a._w);
                h._lastHover = a;
                h._evOnMouseOver([
                    new Date(a._date.getFullYear(), a._date.getMonth(), a._date.getDate(), 0, 0, 0, 0),
                    u
                ]);
                a = null;
            }
        };
        this.contDates.onmouseout = function (a) {
            h._clearDayHover(a || event);
        };
        this._lastHover = null;
        this._clearDayHover = function (a) {
            if (!this._lastHover) {
                return;
            }
            this._lastHover._css_hover = false;
            this._updateCellStyle(this._lastHover._q, this._lastHover._w);
            if (a != null) {
                h._evOnMouseOut([
                    new Date(this._lastHover._date.getFullYear(), this._lastHover._date.getMonth(), this._lastHover._date.getDate(), 0, 0, 0, 0),
                    a
                ]);
            }
            this._lastHover = null;
        };
        for (var c_1 = 0; c_1 < 6; c_1++) {
            var mEl = document.createElement("UL");
            mEl.className = "dhtmlxcalendar_line";
            this.contDates.appendChild(mEl);
            for (var o = 0; o <= 7; o++) {
                var rLiEl = document.createElement("LI");
                if (o == 0) {
                    rLiEl.className = "dhtmlxcalendar_cell_wn";
                }
                else {
                    rLiEl.className = "dhtmlxcalendar_cell";
                }
                mEl.appendChild(rLiEl);
            }
        }
        this.contTime = document.createElement("DIV");
        this.contTime.className = "dhtmlxcalendar_time_cont";
        this.contTime.style.display = "none";
        this.base.firstChild.appendChild(this.contTime);
        this._adjustTimeCont();
        m = document.createElement("UL");
        m.className = "dhtmlxcalendar_line";
        this.contTime.appendChild(m);
        r = document.createElement("LI");
        r.className = "dhtmlxcalendar_cell dhtmlxcalendar_time_hdr";
        r.innerHTML =
            "<div class='dhtmlxcalendar_time_img'></div><span class='dhtmlxcalendar_label_hours'></span><span class='dhtmlxcalendar_label_colon'>:</span><span class='dhtmlxcalendar_label_minutes'></span><span class='dhtmlxcalendar_label_clear'>" +
                this.langData[this.lang].clear +
                "</span><span class='dhtmlxcalendar_label_today'>" +
                this.langData[this.lang].today +
                "</span>";
        m.appendChild(r);
        r.onclick = function (v) {
            v = v || event;
            if (v.type == "touchstart" && v.preventDefault != null) {
                v.preventDefault();
            }
            var a = v.target || v.srcElement;
            if (a.tagName != null &&
                a.tagName.toLowerCase() == "span" &&
                a._par == true &&
                a.parentNode != null) {
                a = a.parentNode;
            }
            var u = null, w = null;
            if (a.className && a.className == "dhtmlxcalendar_label_hours") {
                v.cancelBubble = true;
                u =
                    h.contMonth.offsetHeight +
                        h.contDays.offsetHeight +
                        h.contDates.offsetHeight +
                        a.offsetTop;
                h._showSelector("hours", Math.round(a.offsetLeft + a.offsetWidth / 2), u - 2, "selector_hours", true);
                return;
            }
            if (a.className && a.className == "dhtmlxcalendar_label_minutes") {
                v.cancelBubble = true;
                if (h._minutesInterval == 1) {
                    w = h.getFormatedDate("%i");
                    a.innerHTML =
                        "<span class='dhtmlxcalendar_selected_date'>" +
                            w.charAt(0) +
                            "</span>" +
                            w.charAt(1);
                    a.firstChild._par = true;
                    h._selectorMode = 1;
                }
                u =
                    h.contMonth.offsetHeight +
                        h.contDays.offsetHeight +
                        h.contDates.offsetHeight +
                        a.offsetTop;
                h._showSelector("minutes", Math.round(a.offsetLeft + a.offsetWidth / 2), u - 2, "selector_minutes", true);
                return;
            }
            h._hideSelector();
            if (a.className && a.className == "dhtmlxcalendar_label_today") {
                w = new Date();
                w = new Date(w.getFullYear(), w.getMonth(), w.getDate(), h._activeDate.getHours(), h._activeDate.getMinutes(), h._activeDate.getSeconds(), h._activeDate.getMilliseconds());
                h.setDate(w);
                h._updateInp();
                h.callEvent("onButtonClick", [w]);
            }
            if (a.className && a.className == "dhtmlxcalendar_label_clear") {
                h._nullDate = true;
                h._drawMonth(new Date());
                h._updateInp();
                h.callEvent("onButtonClick", [null]);
            }
        };
        if (this.conf.touch == true) {
            r.ontouchstart = r.onclick;
        }
        this._activeMonth = null;
        this._activeDate = new Date();
        this._activeDateCell = null;
        this._minutesInterval = 5;
        this._initSelector = function (D, x) {
            if (!this._selCover) {
                this._selCover = document.createElement("DIV");
                this._selCover.className = "dhtmlxcalendar_selector_cover";
                this.base.firstChild.appendChild(this._selCover);
            }
            if (!this._sel) {
                this._sel = document.createElement("DIV");
                this._sel.className = "dhtmlxcalendar_selector_obj";
                this.base.firstChild.appendChild(this._sel);
                this._sel.appendChild(document.createElement("TABLE"));
                this._sel.firstChild.className = "dhtmlxcalendar_selector_table";
                this._sel.firstChild.cellSpacing = 0;
                this._sel.firstChild.cellPadding = 0;
                this._sel.firstChild.border = 0;
                this._sel.firstChild.appendChild(document.createElement("TBODY"));
                this._sel.firstChild.firstChild.appendChild(document.createElement("TR"));
                this._sel.firstChild.firstChild.firstChild.appendChild(document.createElement("TD"));
                this._sel.firstChild.firstChild.firstChild.appendChild(document.createElement("TD"));
                this._sel.firstChild.firstChild.firstChild.appendChild(document.createElement("TD"));
                this._sel.firstChild.firstChild.firstChild.childNodes[0].className =
                    "dhtmlxcalendar_selector_cell_left";
                this._sel.firstChild.firstChild.firstChild.childNodes[1].className =
                    "dhtmlxcalendar_selector_cell_middle";
                this._sel.firstChild.firstChild.firstChild.childNodes[2].className =
                    "dhtmlxcalendar_selector_cell_right";
                this._sel.firstChild.firstChild.firstChild.childNodes[0].innerHTML =
                    "&nbsp;";
                this._sel.firstChild.firstChild.firstChild.childNodes[2].innerHTML =
                    "&nbsp;";
                this._sel.firstChild.firstChild.firstChild.childNodes[0].onmouseover = function () {
                    this.className =
                        "dhtmlxcalendar_selector_cell_left dhtmlxcalendar_selector_cell_left_hover";
                };
                this._sel.firstChild.firstChild.firstChild.childNodes[0].onmouseout = function () {
                    this.className = "dhtmlxcalendar_selector_cell_left";
                };
                this._sel.firstChild.firstChild.firstChild.childNodes[2].onmouseover = function () {
                    this.className =
                        "dhtmlxcalendar_selector_cell_right dhtmlxcalendar_selector_cell_right_hover";
                };
                this._sel.firstChild.firstChild.firstChild.childNodes[2].onmouseout = function () {
                    this.className = "dhtmlxcalendar_selector_cell_right";
                };
                this._sel.onmouseover = function (H) {
                    H = H || event;
                    var w = H.target || H.srcElement;
                    if (w._cell === true) {
                        if (h._selHover != w) {
                            h._clearSelHover();
                        }
                        if (String(w.className).match(/^\s{0,}dhtmlxcalendar_selector_cell\s{0,}$/gi) != null) {
                            w.className += " dhtmlxcalendar_selector_cell_hover";
                            h._selHover = w;
                        }
                    }
                };
                this._sel.onmouseout = function () {
                    h._clearSelHover();
                };
                this._sel.firstChild.firstChild.firstChild.childNodes[0].onclick = function (w) {
                    w = w || event;
                    if (w.type == "touchstart" && w.preventDefault != null) {
                        w.preventDefault();
                    }
                    w.cancelBubble = true;
                    h._scrollYears(-1);
                };
                this._sel.firstChild.firstChild.firstChild.childNodes[2].onclick = function (w) {
                    w = w || event;
                    if (w.type == "touchstart" && w.preventDefault != null) {
                        w.preventDefault();
                    }
                    w.cancelBubble = true;
                    h._scrollYears(1);
                };
                if (this.conf.touch == true) {
                    this._sel.firstChild.firstChild.firstChild.childNodes[0].ontouchstart = this._sel.firstChild.firstChild.firstChild.childNodes[0].onclick;
                    this._sel.firstChild.firstChild.firstChild.childNodes[2].ontouchstart = this._sel.firstChild.firstChild.firstChild.childNodes[2].onclick;
                }
                this._sel._ta = {};
                this._selHover = null;
                this._sel.appendChild(document.createElement("DIV"));
                this._sel.lastChild.className = "dhtmlxcalendar_selector_obj_arrow";
            }
            if (this._sel._ta[D] == true) {
                return;
            }
            if (D == "month") {
                this._msCells = {};
                this.msCont = document.createElement("DIV");
                this.msCont.className = "dhtmlxcalendar_area_" + x;
                this._sel.firstChild.firstChild.firstChild.childNodes[1].appendChild(this.msCont);
                var u = 0;
                for (var a = 0; a < 4; a++) {
                    var C = document.createElement("UL");
                    C.className = "dhtmlxcalendar_selector_line";
                    this.msCont.appendChild(C);
                    for (var E = 0; E < 3; E++) {
                        var F = document.createElement("LI");
                        F.innerHTML = this.langData[this.lang].monthesSNames[u];
                        F.className = "dhtmlxcalendar_selector_cell";
                        C.appendChild(F);
                        F._month = u;
                        F._cell = true;
                        this._msCells[u++] = F;
                    }
                }
                this.msCont.onclick = function (H) {
                    H = H || event;
                    if (H.type == "touchstart" && H.preventDefault != null) {
                        H.preventDefault();
                    }
                    H.cancelBubble = true;
                    var w = H.target || H.srcElement;
                    if (w._month != null) {
                        h._hideSelector();
                        h._updateActiveMonth();
                        h._drawMonth(new Date(h._activeMonth.getFullYear(), w._month, 1, 0, 0, 0, 0));
                        h._doOnSelectorChange();
                    }
                };
                if (this.conf.touch == true) {
                    this.msCont.ontouchstart = this.msCont.onclick;
                }
            }
            if (D == "year") {
                this._ysCells = {};
                this.ysCont = document.createElement("DIV");
                this.ysCont.className = "dhtmlxcalendar_area_" + x;
                this._sel.firstChild.firstChild.firstChild.childNodes[1].appendChild(this.ysCont);
                for (var a_1 = 0; a_1 < 4; a_1++) {
                    var CEl = document.createElement("UL");
                    CEl.className = "dhtmlxcalendar_selector_line";
                    this.ysCont.appendChild(CEl);
                    for (var ENum = 0; ENum < 3; ENum++) {
                        var FEl = document.createElement("LI");
                        FEl.className = "dhtmlxcalendar_selector_cell";
                        FEl._cell = true;
                        CEl.appendChild(FEl);
                    }
                }
                this.ysCont.onclick = function (H) {
                    H = H || event;
                    if (H.type == "touchstart" && H.preventDefault != null) {
                        H.preventDefault();
                    }
                    H.cancelBubble = true;
                    var w = H.target || H.srcElement;
                    if (w._year != null) {
                        h._hideSelector();
                        h._drawMonth(new Date(w._year, h._activeMonth.getMonth(), 1, 0, 0, 0, 0));
                        h._doOnSelectorChange();
                    }
                };
                if (this.conf.touch == true) {
                    this.ysCont.ontouchstart = this.ysCont.onclick;
                }
            }
            if (D == "hours") {
                this._hsCells = {};
                this.hsCont = document.createElement("DIV");
                this.hsCont.className = "dhtmlxcalendar_area_" + x;
                this._sel.firstChild.firstChild.firstChild.childNodes[1].appendChild(this.hsCont);
                var uNum = 0;
                for (var a_2 = 0; a_2 < 4; a_2++) {
                    var CElObj = document.createElement("UL");
                    CElObj.className = "dhtmlxcalendar_selector_line";
                    this.hsCont.appendChild(CElObj);
                    for (var ENums = 0; ENums < 6; ENums++) {
                        var FElObj = document.createElement("LI");
                        FElObj.innerHTML = this._fixLength(uNum, 2);
                        FElObj.className = "dhtmlxcalendar_selector_cell";
                        CElObj.appendChild(FElObj);
                        FElObj._hours = uNum;
                        FElObj._cell = true;
                        this._hsCells[uNum++] = FElObj;
                    }
                }
                this.hsCont.onclick = function (H) {
                    H = H || event;
                    if (H.type == "touchstart" && H.preventDefault != null) {
                        H.preventDefault();
                    }
                    H.cancelBubble = true;
                    var w = H.target || H.srcElement;
                    if (w._hours != null) {
                        h._hideSelector();
                        h._activeDate.setHours(w._hours);
                        h._updateActiveHours();
                        h._updateVisibleHours();
                        h._doOnSelectorChange();
                        h.callEvent("onTimeChange", [new Date(h._activeDate.getTime())]);
                    }
                };
                if (this.conf.touch == true) {
                    this.hsCont.ontouchstart = this.hsCont.onclick;
                }
            }
            if (D == "minutes") {
                var A = 4;
                var v = 3;
                var y = 2;
                if (this._minutesInterval == 1) {
                    if (this._selectorMode == 1) {
                        A = 2;
                        v = 3;
                        y = 1;
                    }
                    else {
                        A = 2;
                        v = 5;
                        y = 1;
                        x += "5";
                    }
                }
                if (this._minutesInterval == 10) {
                    A = 2;
                }
                if (this._minutesInterval == 15) {
                    A = 1;
                    v = 4;
                    x += "4";
                }
                this._rsCells = {};
                this.rsCont = document.createElement("DIV");
                this.rsCont.className = "dhtmlxcalendar_area_" + x;
                this._sel.firstChild.firstChild.firstChild.childNodes[1].appendChild(this.rsCont);
                var uNums = 0;
                for (var aNums = 0; aNums < A; aNums++) {
                    var CElObjUl = document.createElement("UL");
                    CElObjUl.className = "dhtmlxcalendar_selector_line";
                    this.rsCont.appendChild(CElObjUl);
                    for (var EE = 0; EE < v; EE++) {
                        var FLiEl = document.createElement("LI");
                        FLiEl.innerHTML = y > 1 ? this._fixLength(uNums, y) : uNums;
                        FLiEl.className = "dhtmlxcalendar_selector_cell";
                        CElObjUl.appendChild(FLiEl);
                        FLiEl._minutes = uNums;
                        FLiEl._cell = true;
                        this._rsCells[uNums] = FLiEl;
                        uNums += this._minutesInterval;
                    }
                }
                this.rsCont.onclick = function (I) {
                    I = I || event;
                    if (I.type == "touchstart" && I.preventDefault != null) {
                        I.preventDefault();
                    }
                    I.cancelBubble = true;
                    var H = I.target || I.srcElement;
                    if (H._minutes != null) {
                        if (h._minutesInterval == 1) {
                            var w = h.getFormatedDate("%i");
                            if (h._selectorMode == 1) {
                                w = H._minutes.toString() + w.charAt(1);
                            }
                            else {
                                w = w.charAt(0) + H._minutes.toString();
                            }
                            h._activeDate.setMinutes(Number(w));
                            h.callEvent("onTimeChange", [new Date(h._activeDate.getTime())]);
                            h._hideSelector();
                            if (h._selectorMode == 1) {
                                h._updateVisibleMinutes(true);
                                h._selectorMode = 2;
                                h._showSelector("minutes", h._sel._x, h._sel._y, "selector_minutes", true);
                                h._updateActiveMinutes();
                                return;
                            }
                            else {
                                h._selectorMode = 1;
                            }
                        }
                        else {
                            h._hideSelector();
                            h._activeDate.setMinutes(H._minutes);
                            h._updateActiveMinutes();
                            h.callEvent("onTimeChange", [new Date(h._activeDate.getTime())]);
                        }
                        h._updateVisibleMinutes();
                        h._doOnSelectorChange();
                    }
                };
                if (this.conf.touch == true) {
                    this.rsCont.ontouchstart = this.rsCont.onclick;
                }
            }
            this._sel._ta[D] = true;
        };
        this._dateFormat = "";
        this._dateFormatRE = null;
        this.setDateFormat = function (x) {
            var w = {};
            if (this._strToDate != null) {
                for (var u in this.i) {
                    if (this.i[u].input != null && this.i[u].input.value.length > 0) {
                        var y = this._strToDate(this.i[u].input.value, this._dateFormat ||
                            this.langData[this.lang].dateformat ||
                            "%Y-%m-%d");
                        if (y instanceof Date) {
                            w[u] = y;
                        }
                    }
                }
            }
            this._dateFormat = x;
            var v = String(this._dateFormat).replace(/%[a-zA-Z]+/g, function (a) {
                var A = a.replace(/%/, "");
                switch (A) {
                    case "n":
                    case "h":
                    case "j":
                    case "g":
                    case "G":
                        return "\\d{1,2}";
                    case "m":
                    case "d":
                    case "H":
                    case "i":
                    case "s":
                    case "y":
                        return "\\d{2}";
                    case "Y":
                        return "\\d{4}";
                    case "M":
                        return ("(" +
                            h.langData[h.lang].monthesSNames.join("|").toLowerCase() +
                            "){1,}");
                    case "F":
                        return ("(" +
                            h.langData[h.lang].monthesFNames.join("|").toLowerCase() +
                            "){1,}");
                    case "D":
                        return "[a-z]{2}";
                    case "a":
                    case "A":
                        return "AM|PM";
                    case "u":
                        return "\\d{1,6}";
                    case "P":
                        return "[\\+\\-]\\d{1,2}\\:\\d{1,2}";
                }
                return a;
            });
            this._dateFormatRE = new RegExp(v, "i");
            for (var u_1 in w) {
                this.i[u_1].input.value = this._dateToStr(w[u_1]);
            }
            w = null;
        };
        this.setDateFormat(this.langData[this.lang].dateformat || "%Y-%m-%d");
        this._activeInp = null;
        this.pos = "bottom";
        this._rangeActive = false;
        this._rangeFrom = null;
        this._rangeTo = null;
        this._rangeSet = {};
        this._holidays = {};
        this._tipData = {};
        this._tipTM = null;
        this._tipTMTime = 400;
        this._tipEvs = false;
        this._tipPopup = null;
        this._tipCellDate = null;
        this._tipCellDim = null;
        this._doOnClick = function (u) {
            u = u || event;
            var a = u.target || u.srcElement;
            if (a._dhtmlxcalendar_uid &&
                a._dhtmlxcalendar_uid != h._activeInp &&
                h._isVisible() &&
                h._activeInp) {
                h._hide();
                return;
            }
            if (!a._dhtmlxcalendar_uid || !h.i[a._dhtmlxcalendar_uid]) {
                if (h._isSelectorVisible()) {
                    h._hideSelector();
                }
                else {
                    if (!h._hasParent && h._isVisible()) {
                        h._hide();
                    }
                }
            }
        };
        this._doOnKeyDown = function (a) {
            a = a || event;
            if (a.keyCode == 27 || a.keyCode == 13) {
                if (h._isSelectorVisible()) {
                    h._hideSelector();
                }
                else {
                    if (h._isVisible() && !h._hasParent) {
                        h._hide();
                    }
                }
            }
        };
        this._doOnInpClick = function (u) {
            u = u || event;
            if (u.type == "touchstart" && u.preventDefault != null) {
                u.preventDefault();
            }
            var a = u.target || u.srcElement;
            if (!a._dhtmlxcalendar_uid) {
                return;
            }
            if (!h._listenerEnabled) {
                h._updateFromInput(a);
            }
            h._show(a._dhtmlxcalendar_uid, true);
        };
        this._doOnInpKeyUp = function (u) {
            u = u || event;
            var a = u.target || u.srcElement;
            if (u.keyCode == 13 || !a._dhtmlxcalendar_uid) {
                return;
            }
            if (!h._listenerEnabled) {
                h._updateFromInput(a);
            }
        };
        this._doOnBtnClick = function (u) {
            u = u || event;
            if (u.type == "touchstart" && u.preventDefault != null) {
                u.preventDefault();
            }
            var a = u.target || u.srcElement;
            if (!a._dhtmlxcalendar_uid) {
                return;
            }
            if (h.i[a._dhtmlxcalendar_uid].input != null) {
                h._updateFromInput(h.i[a._dhtmlxcalendar_uid].input);
            }
            h._show(a._dhtmlxcalendar_uid, true);
        };
        this._doOnUnload = function () {
            if (h && h.unload) {
                h.unload();
            }
        };
        if (typeof window.addEventListener == "function") {
            document.body.addEventListener("click", h._doOnClick, false);
            window.addEventListener("keydown", h._doOnKeyDown, false);
            window.addEventListener("unload", h._doOnUnload, false);
            if (this.conf.touch == true) {
                document.body.addEventListener("touchstart", h._doOnClick, false);
            }
        }
        else {
            document.body.attachEvent("onclick", h._doOnClick);
            document.body.attachEvent("onkeydown", h._doOnKeyDown);
            window.attachEvent("onunload", h._doOnUnload);
        }
        this._attachEventsToObject = function (u) {
            if (this.i[u].button != null) {
                this.i[u].button._dhtmlxcalendar_uid = u;
                if (typeof window.addEventListener == "function") {
                    this.i[u].button.addEventListener("click", h._doOnBtnClick, false);
                    if (this.conf.touch == true) {
                        this.i[u].button.addEventListener("touchstart", h._doOnBtnClick, false);
                    }
                }
                else {
                    this.i[u].button.attachEvent("onclick", h._doOnBtnClick);
                }
            }
            else {
                if (this.i[u].input != null) {
                    this.i[u].input._dhtmlxcalendar_uid = u;
                    if (typeof window.addEventListener == "function") {
                        this.i[u].input.addEventListener("click", h._doOnInpClick, false);
                        this.i[u].input.addEventListener("keyup", h._doOnInpKeyUp, false);
                        if (this.conf.touch == true) {
                            this.i[u].input.addEventListener("touchstart", h._doOnInpClick, false);
                        }
                    }
                    else {
                        this.i[u].input.attachEvent("onclick", h._doOnInpClick);
                        this.i[u].input.attachEvent("onkeyup", h._doOnInpKeyUp);
                    }
                }
            }
        };
        this._detachEventsFromObject = function (u) {
            if (this.i[u].button != null) {
                if (typeof window.addEventListener == "function") {
                    this.i[u].button.removeEventListener("click", h._doOnBtnClick, false);
                    if (this.conf.touch == true) {
                        this.i[u].button.removeEventListener("touchstart", h._doOnBtnClick, false);
                    }
                }
                else {
                    this.i[u].button.detachEvent("onclick", h._doOnBtnClick);
                }
            }
            else {
                if (this.i[u].input != null) {
                    if (typeof window.addEventListener == "function") {
                        this.i[u].input.removeEventListener("click", h._doOnInpClick, false);
                        this.i[u].input.removeEventListener("keyup", h._doOnInpKeyUp, false);
                        if (this.conf.touch == true) {
                            this.i[u].input.removeEventListener("touchstart", h._doOnInpClick, false);
                        }
                    }
                    else {
                        this.i[u].input.detachEvent("onclick", h._doOnInpClick);
                        this.i[u].input.detachEvent("onkeyup", h._doOnInpKeyUp);
                    }
                }
            }
        };
        this.enableListener = function (a) {
            if (!a) {
                return;
            }
            if (typeof window.addEventListener == "function") {
                a.addEventListener("focus", h._listenerEvFocus, false);
                a.addEventListener("blur", h._listenerEvBlur, false);
            }
            else {
                a.attachEvent("onfocus", h._listenerEvFocus);
                a.attachEvent("onblur", h._listenerEvBlur);
            }
            a = null;
        };
        this.disableListener = function (a) {
            if (!a) {
                return;
            }
            a._f0 = false;
            if (this._tmListener) {
                window.clearTimeout(this._tmListener);
            }
            if (typeof window.addEventListener == "function") {
                a.removeEventListener("focus", h._listenerEvFocus, false);
                a.removeEventListener("blur", h._listenerEvBlur, false);
            }
            else {
                a.detachEvent("onfocus", h._listenerEvFocus);
                a.detachEvent("onblur", h._listenerEvBlur);
            }
            a = null;
        };
        this._startListener = function (a) {
            if (this._tmListener) {
                window.clearTimeout(this._tmListener);
            }
            if (typeof a._v1 == "undefined") {
                a._v1 = a.value;
            }
            if (a._v1 != a.value) {
                this._updateFromInput(a);
                a._v1 = a.value;
            }
            if (a._f0) {
                this._tmListener = window.setTimeout(function () {
                    h._startListener(a);
                }, 100);
            }
        };
        this._listenerEvFocus = function (u) {
            u = u || event;
            var a = u.target || u.srcElement;
            a._f0 = true;
            h._startListener(a);
            a = null;
        };
        for (var n in this.i) {
            this._attachEventsToObject(n);
        }
        dhx4._eventable(this);
        this._evOnArrowClick = function (a) {
            return this.callEvent("onArrowClick", a);
        };
        this._evOnClick = function (a) {
            return this.callEvent("onClick", a);
        };
        this._evOnMouseOut = function (a) {
            return this.callEvent("onMouseOut", a);
        };
        this._evOnMouseOver = function (a) {
            return this.callEvent("onMouseOver", a);
        };
        this.unload = function () {
            this._activeDate = null;
            this._activeDateCell = null;
            this._activeInp = null;
            this._activeMonth = null;
            this._dateFormat = null;
            this._dateFormatRE = null;
            this._lastHover = null;
            if (this._tmListener) {
                window.clearTimeout(this._tmListener);
            }
            this._tmListener = null;
            if (typeof window.addEventListener == "function") {
                document.body.removeEventListener("click", h._doOnClick, false);
                window.removeEventListener("keydown", h._doOnKeyDown, false);
                window.removeEventListener("unload", h._doOnUnload, false);
                if (this.conf.touch == true) {
                    document.body.removeEventListener("touchstart", h._doOnClick, false);
                }
            }
            else {
                document.body.detachEvent("onclick", h._doOnClick);
                document.body.detachEvent("onkeydown", h._doOnKeyDown);
                window.detachEvent("onunload", h._doOnKeyDown);
            }
            this._doOnClick = null;
            this._doOnKeyDown = null;
            this._doOnUnload = null;
            for (var u in this.i) {
                this.i[u]._dhtmlxcalendar_uid = null;
                this._detachEventsFromObject(u);
                this.disableListener(this.i[u].input);
                this.i[u] = null;
                delete this.i[u];
            }
            this.i = null;
            this._doOnInpClick = null;
            this._doOnInpKeyUp = null;
            dhx4._eventable(this, "clear");
            this.contMonth.onselectstart = null;
            this.contMonth.firstChild.firstChild.onclick = null;
            this.contMonth.firstChild.firstChild.ontouchstart = null;
            this.contMonth.firstChild.firstChild.firstChild.onmouseover = null;
            this.contMonth.firstChild.firstChild.firstChild.onmouseout = null;
            this.contMonth.firstChild.firstChild.lastChild.onmouseover = null;
            this.contMonth.firstChild.firstChild.lastChild.onmouseout = null;
            while (this.contMonth.firstChild.firstChild.childNodes.length > 0) {
                this.contMonth.firstChild.firstChild.removeChild(this.contMonth.firstChild.firstChild.lastChild);
            }
            this.contMonth.firstChild.removeChild(this.contMonth.firstChild.firstChild);
            this.contMonth.removeChild(this.contMonth.firstChild);
            this.contMonth.parentNode.removeChild(this.contMonth);
            this.contMonth = null;
            while (this.contDays.firstChild.childNodes.length > 0) {
                this.contDays.firstChild.removeChild(this.contDays.firstChild.lastChild);
            }
            this.contDays.removeChild(this.contDays.firstChild);
            this.contDays.parentNode.removeChild(this.contDays);
            this.contDays = null;
            this.contDates.onclick = null;
            this.contDates.ontouchstart = null;
            this.contDates.onmouseover = null;
            this.contDates.onmouseout = null;
            while (this.contDates.childNodes.length > 0) {
                while (this.contDates.lastChild.childNodes.length > 0) {
                    this.contDates.lastChild.lastChild._css_date = null;
                    this.contDates.lastChild.lastChild._css_month = null;
                    this.contDates.lastChild.lastChild._css_weekend = null;
                    this.contDates.lastChild.lastChild._css_hover = null;
                    this.contDates.lastChild.lastChild._date = null;
                    this.contDates.lastChild.lastChild._q = null;
                    this.contDates.lastChild.lastChild._w = null;
                    this.contDates.lastChild.removeChild(this.contDates.lastChild.lastChild);
                }
                this.contDates.removeChild(this.contDates.lastChild);
            }
            this.contDates.parentNode.removeChild(this.contDates);
            this.contDates = null;
            this.contTime.firstChild.firstChild.onclick = null;
            this.contTime.firstChild.firstChild.ontouchstart = null;
            while (this.contTime.firstChild.firstChild.childNodes.length > 0) {
                this.contTime.firstChild.firstChild.removeChild(this.contTime.firstChild.firstChild.lastChild);
            }
            this.contTime.firstChild.removeChild(this.contTime.firstChild.firstChild);
            this.contTime.removeChild(this.contTime.firstChild);
            this.contTime.parentNode.removeChild(this.contTime);
            this.contTime = null;
            this._lastHover = null;
            this._unloadSelector("month");
            this._unloadSelector("year");
            this._unloadSelector("hours");
            this._unloadSelector("minutes");
            if (this._selCover) {
                this._selCover.parentNode.removeChild(this._selCover);
                this._selCover = null;
            }
            if (this._sel) {
                for (var u_2 in this._sel._ta) {
                    this._sel._ta[u_2] = null;
                }
                this._sel._ta = null;
                this._sel._t = null;
                this._sel.onmouseover = null;
                this._sel.onmouseout = null;
                while (this._sel.firstChild.firstChild.firstChild.childNodes.length > 0) {
                    this._sel.firstChild.firstChild.firstChild.lastChild.onclick = null;
                    this._sel.firstChild.firstChild.firstChild.lastChild.onmouseover = null;
                    this._sel.firstChild.firstChild.firstChild.lastChild.onmouseout = null;
                    this._sel.firstChild.firstChild.firstChild.removeChild(this._sel.firstChild.firstChild.firstChild.lastChild);
                }
                this._sel.firstChild.firstChild.removeChild(this._sel.firstChild.firstChild.firstChild);
                this._sel.firstChild.removeChild(this._sel.firstChild.firstChild);
                while (this._sel.childNodes.length > 0) {
                    this._sel.removeChild(this._sel.lastChild);
                }
                this._sel.parentNode.removeChild(this._sel);
                this._sel = null;
            }
            this.base.onclick = null;
            this.base.onmousedown = null;
            this.base.ontouchstart = null;
            this.base.onmouseout = null;
            this.base.parentNode.removeChild(this.base);
            this.base = null;
            this._clearDayHover = null;
            this._clearSelHover = null;
            this._doOnSelectorChange = null;
            this._doOnSelectorShow = null;
            this._drawMonth = null;
            this._fixLength = null;
            this._ifrSize = null;
            this._hide = null;
            this._hideSelector = null;
            this._initSelector = null;
            this._isSelectorVisible = null;
            this._isVisible = null;
            this._scrollYears = null;
            this._show = null;
            this._showSelector = null;
            this._strToDate = null;
            this._updateActiveHours = null;
            this._updateActiveMinutes = null;
            this._updateActiveMonth = null;
            this._updateActiveYear = null;
            this._updateCellStyle = null;
            this._updateDateStr = null;
            this._updateVisibleHours = null;
            this._updateVisibleMinutes = null;
            this._updateYearsList = null;
            this.enableIframe = null;
            this.hide = null;
            this.hideTime = null;
            this.setDate = null;
            this.setDateFormat = null;
            this.setYearsRange = null;
            this.show = null;
            this.showTime = null;
            this.unload = null;
            if (this._tipPopup != null) {
                this._tipPopup.unload();
                this._tipPopup = null;
            }
            for (var u_3 in this) {
                delete this[u_3];
            }
            h = null;
        };
        this.setDate(this._activeDate);
        return this;
    }
    return dhtmlXCalendarObject;
})();
dhtmlXCalendarObject.prototype.lang = "en";
dhtmlXCalendarObject.prototype.langData = {
    en: {
        dateformat: "%Y-%m-%d",
        hdrformat: "%F %Y",
        monthesFNames: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthesSNames: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        daysFNames: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        daysSNames: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
        weekstart: 1,
        weekname: "w",
        today: "Today",
        clear: "Clear"
    }
};
dhtmlXCalendarObject.prototype._buildMonthHdr = function (h) {
    var c = this;
    var g = function (l) {
        return String(l).length == 1 ? "0" + String(l) : l;
    };
    var a = function (l, m) {
        return ("<span class='dhtmlxcalendar_month_label_" + l + "'>" + m + "</span>");
    };
    var e = String(this.langData[this.lang].hdrformat || "%F %Y").replace(/%[a-z]/gi, function (l) {
        switch (l) {
            case "%m":
                return a("month", g(h.getMonth() + 1));
            case "%n":
                return a("month", h.getMonth() + 1);
            case "%M":
                return a("month", c.langData[c.lang].monthesSNames[h.getMonth()]);
            case "%F":
                return a("month", c.langData[c.lang].monthesFNames[h.getMonth()]);
            case "%y":
                return a("year", g(h.getYear() % 100));
            case "%Y":
                return a("year", h.getFullYear());
            case "%%":
                return "%";
            default:
                return l;
        }
    });
    c = g = a = null;
    return e;
};
dhtmlXCalendarObject.prototype.enableIframe = function (a) {
    if (a == true) {
        if (!this._ifr) {
            this._ifr = document.createElement("IFRAME");
            this._ifr.frameBorder = 0;
            this._ifr.border = 0;
            this._ifr.setAttribute("src", "javascript:false;");
            this._ifr.className = "dhtmlxcalendar_ifr";
            this._ifr.onload = function () {
                this.onload = null;
                this.contentWindow.document.open("text/html", "replace");
                this.contentWindow.document.write("<html><head><style>html,body{width:100%;height:100%;overflow:hidden;margin:0px;}</style></head><body</body></html>");
            };
            this.base.parentNode.insertBefore(this._ifr, this.base);
            this._ifrSize();
        }
    }
    else {
        if (this._ifr) {
            this._ifr.parentNode.removeChild(this._ifr);
            this._ifr = null;
        }
    }
};
dhtmlXCalendarObject.prototype._ifrSize = function () {
    if (this._ifr) {
        this._ifr.style.left = this.base.style.left;
        this._ifr.style.top = this.base.style.top;
        this._ifr.style.width = this.base.offsetWidth + "px";
        this._ifr.style.height = this.base.offsetHeight + "px";
    }
};

dhtmlXCalendarObject.prototype._dateStrings = function () {
    var a = this.langData[this.lang];
    return {
        monthFullName: a.monthesFNames,
        monthShortName: a.monthesSNames,
        dayFullName: a.daysFNames,
        dayShortName: a.daysSNames
    };
};
dhtmlXCalendarObject.prototype._strToDate = function (c, a) {
    return dhx4.str2date(c, a || this._dateFormat, this._dateStrings());
};
dhtmlXCalendarObject.prototype._dateToStr = function (c, a) {
    return dhx4.date2str(c, a || this._dateFormat, this._dateStrings());
};

dhtmlXCalendarObject.prototype.langData["ch"] = {
    dateformat: "%Y-%m-%d",
    monthesFNames: [
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月"
    ],
    monthesSNames: [
        "一月",
        "二月",
        "三月",
        "四月",
        "五月",
        "六月",
        "七月",
        "八月",
        "九月",
        "十月",
        "十一月",
        "十二月"
    ],
    daysFNames: [
        "星期天",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六"
    ],
    daysSNames: ["天", "一", "二", "三", "四", "五", "六"],
    weekstart: 1,
    weekname: "w",
    today: "今天",
    clear: "清空"
};

window.dhtmlxDblCalendarObject = window.dhtmlXDoubleCalendarObject = window.dhtmlXDoubleCalendar = function (c) {
    var a = this;
    this.leftCalendar = new dhtmlXCalendarObject(c);
    this.leftCalendar.hideTime();
    this.rightCalendar = new dhtmlXCalendarObject(c);
    this.rightCalendar.hideTime();
    this.leftCalendar.attachEvent("onClick", function (e) {
        a._updateRange("rightCalendar", e, null);
        a._evOnClick(["left", e]);
    });
    this.rightCalendar.attachEvent("onClick", function (e) {
        a._updateRange("leftCalendar", null, e);
        a._evOnClick(["right", e]);
    });
    this.leftCalendar.attachEvent("onBeforeChange", function (e) {
        return a._evOnBeforeChange(["left", e]);
    });
    this.rightCalendar.attachEvent("onBeforeChange", function (e) {
        return a._evOnBeforeChange(["right", e]);
    });
    this.show = function () {
        this.leftCalendar.show();
        this.rightCalendar.base.style.marginLeft =
            this.leftCalendar.base.offsetWidth - 1 + "px";
        this.rightCalendar.show();
    };
    this.hide = function () {
        this.leftCalendar.hide();
        this.rightCalendar.hide();
    };
    this.setDateFormat = function (e) {
        this.leftCalendar.setDateFormat(e);
        this.rightCalendar.setDateFormat(e);
    };
    this.setDates = function (g, e) {
        if (g != null) {
            this.leftCalendar.setDate(g);
        }
        if (e != null) {
            this.rightCalendar.setDate(e);
        }
        this._updateRange();
    };
    this._updateRange = function (e, h, g) {
        if (arguments.length == 3) {
            (e == "leftCalendar"
                ? this.leftCalendar
                : this.rightCalendar).setSensitiveRange(h, g);
        }
        else {
            this.leftCalendar.setSensitiveRange(null, this.rightCalendar.getDate());
            this.rightCalendar.setSensitiveRange(this.leftCalendar.getDate(), null);
        }
    };
    this.getFormatedDate = function () {
        return this.leftCalendar.getFormatedDate.apply(this.leftCalendar, arguments);
    };
    this.unload = function () {
        dhx4._eventable(this, "clear");
        this.leftCalendar.unload();
        this.rightCalendar.unload();
        this.leftCalendar = this.rightCalendar = null;
        this._updateRange = null;
        this._evOnClick = null;
        this._evOnBeforeChange = null;
        this.show = null;
        this.hide = null;
        this.setDateFormat = null;
        this.setDates = null;
        this.getFormatedDate = null;
        this.unload = null;
        a = null;
    };
    this._evOnClick = function (e) {
        return this.callEvent("onClick", e);
    };
    this._evOnBeforeChange = function (e) {
        return this.callEvent("onBeforeChange", e);
    };
    dhx4._eventable(this);
    return this;
};

export {dhtmlXDoubleCalendar,dhtmlXCalendarObject} ;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXCalendar/dhtmlXCalendarObject.js